import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "bootstrap-icons/font/bootstrap-icons.css";
import LoginSignup from "./components/Loginsigup/LoginSignup";
import Dashboard from "./pages/Dashboard";
import AdminDashboard from "./pages/AdminDashboard";
import UserDashboard from "./pages/UserDashboard";
// Admin Company Pages
import CompanyList from "./admin/pages/CompanyList";
import AddCompany from "./admin/pages/AddCompany";
import EditCompany from "./admin/pages/EditCompany";
import UsersPage from "./admin/pages/Adminuser";
import UserProfileForm from "./components/UserProfileForm/UserProfileForm";
import TeamForm from "./components/TeamForm/TeamForm";
import TeamTable from "./components/TeamForm/TeamTable";
import MyAccount from "./components/layout/MyAccount";
import ContactList from "./components/Contactus/ContactList";
import ViewContact from "./components/Contactus/ViewContact";
// Private Route
import PrivateRoute from "../src/components/PrivateRoute";
import AddContact from "./components/Contactus/AddContact";
import EditContact from "./components/Contactus/EditContact";
import MutualManagement from "./components/MutualManagement/MutualManagement";

function App() {
  return (
    <Router>
      <Routes>

        {/* Login Page */}
        <Route path="/" element={<LoginSignup />} />

        {/* Main Dashboard (any logged-in user) */}
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />

        {/* Admin Dashboard */}
        <Route
          path="/admin-dashboard"
          element={
            <PrivateRoute role="admin">
              <AdminDashboard />
            </PrivateRoute>
          }
        />

            <Route
          path="/admin-user"
          element={
            <PrivateRoute role="admin">
              <UsersPage />
            </PrivateRoute>
          }
        />

        {/* User Dashboard */}
        <Route
          path="/user-dashboard"
          element={
            <PrivateRoute role="user">
              <UserDashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/user-profile"
          element={
            <PrivateRoute role="user">
              <UserProfileForm/>
            </PrivateRoute>
          }
        />
        <Route
          path="/Team-meb"
          element={
            <PrivateRoute role="user">
              <TeamForm/>
            </PrivateRoute>
          }
        />

        
         <Route
          path="/My-Account"
          element={
            <PrivateRoute role="user">
              <MyAccount/>
            </PrivateRoute>
          }
        />

           <Route
          path="/ContactMangement"
          element={
            <PrivateRoute role="user">
              <ContactList/>
            </PrivateRoute>
          }
        />

        
         <Route
  path="/view-contact/:id"
  element={
    <PrivateRoute role="user">
      <ViewContact />
    </PrivateRoute>
  }
/>

<Route
  path="/edit-contact/:id"
  element={
    <PrivateRoute role="user">
      <EditContact />
    </PrivateRoute>
  }
/>

         <Route
  path="/AddContact"
  element={
    <PrivateRoute role="user">
      <AddContact />
    </PrivateRoute>
  }
/>


       <Route
  path="/MutualManagement"
  element={
    <PrivateRoute role="user">
      <MutualManagement />
    </PrivateRoute>
  }
/>



         <Route
          path="/Team-view"
          element={
            <PrivateRoute role="user">
              <TeamTable/>
            </PrivateRoute>
          }
        />

        {/* Admin Company Management */}
        <Route
          path="/admin/companies"
          element={
            <PrivateRoute role="admin">
              <CompanyList />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/add-company"
          element={
            <PrivateRoute role="admin">
              <AddCompany />
            </PrivateRoute>
          }
        />
        <Route
          path="/admin/edit-company/:id"
          element={
            <PrivateRoute role="admin">
              <EditCompany />
            </PrivateRoute>
          }
        />

      </Routes>
    </Router>
  );
}

export default App;